import { useNavigate } from "react-router-dom";
import MainContainer from "../../../layout/MainContainer";
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box,
    IconButton,
    Tab,
    Tabs,
    Button,
} from "@mui/material";
import SearchBar from "../../../components/SearchBar";
import { useState } from "react";
import SwitchToggle from "../../../components/SwitchToggle";
import AddEditTone from "../../../Modals/addTone";
import AddIcon from '@mui/icons-material/Add';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const LanguageLibrary = () => {
    const navigate = useNavigate();

    const [rows] = useState([
        { id: 1, language: "English" },
        { id: 2, language: "Spanish" },
        { id: 3, language: "French" },
    ]);
    const rows1 = [
        {
            id: 1,
            sampleUrl: "/audio/calm-female.mp3",
            tags: ["Casual"],
        },
        {
            id: 2,
            sampleUrl: "/audio/calm-female.mp3",
            tags: ["Formal"],
        },
        {
            id: 3,
            sampleUrl: "/audio/calm-female.mp3",
            tags: ["Apologetic"],
        },
        {
            id: 4,
            sampleUrl: "/audio/calm-female.mp3",
            tags: ["Urgent"],
        },
    ];


    const columns = [
        { id: 'language', label: 'Supported Languages' },
        { id: 'actions', label: 'Actions' },
    ];
    const [valueTabs, setValueTabs] = useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };

    const [searchTerm, setSearchTerm] = useState("");
    const [open, setOpen] = useState(false);

    const handleCloseModal = () => {
        setOpen(false);
    };
    return (
        <><>
            <div className="main_title">
                <h1>Language Library</h1>
                <p>
                    <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Language Library
                </p>
            </div>
            
            <div className="table_header">
                <div className="left_s">
                    <Box className="custom_tabs1" sx={{ width: "100%" }}>
                        <Tabs
                            value={valueTabs}
                            onChange={handleChangeTabs}
                            aria-label="basic tabs example"
                            className="custom_tabs_links"
                        >
                            <Tab label="Supported Languages" {...a11yProps(0)} />
                            <Tab label="Tone Samples" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                </div>
            </div>

            <div className="cards">
                <CustomTabPanel value={valueTabs} index={0}>
                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search languages..." />
                            </Box>
                        </div>

                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow hover>
                                    {columns.map((column) => (
                                        <TableCell key={column.id}>{column.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>{row.language}</TableCell>
                                        <TableCell>
                                            <div className="table_actions v2">
                                                <Box>
                                                    <IconButton onClick={() => navigate("/translation-messaging/view")}>
                                                        <img src="/static/images/eye_icon.svg" alt="Edit" />
                                                    </IconButton>
                                                </Box>
                                                <Box>
                                                    <IconButton>
                                                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                    </IconButton>
                                                </Box>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={1}>
                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search Tone..." />
                            </Box>
                        </div>
                        <div className="right_s">

                            <Button className="btn btn_primary" onClick={() => setOpen(true)}><AddIcon /> Add Tone</Button>
                        </div>

                    </div>
                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow hover>
                                    <TableCell>Tone</TableCell>
                                    <TableCell>Tags</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {rows1.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>
                                            <audio controls>
                                                <source src={row.sampleUrl} type="audio/mpeg" />
                                                Your browser does not support the audio element.
                                            </audio>
                                        </TableCell>
                                        <TableCell>
                                            {row.tags?.map((tag, i) => (
                                                <span key={i} className="tag_chip">
                                                    {tag}
                                                </span>
                                            ))}
                                        </TableCell>
                                        <TableCell><SwitchToggle /></TableCell>
                                        <TableCell>
                                            <Box className="table_actions v2">
                                                <IconButton onClick={() => setOpen(true)}>
                                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                </IconButton>
                                                <IconButton>
                                                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                </IconButton>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>

                        </Table>
                    </TableContainer>

                </CustomTabPanel>
            </div>
        </><AddEditTone open={open} onClose={handleCloseModal} setOpen={setOpen} mode="edit" /></>

    );
};

export default LanguageLibrary;
